import { ServiceGroup } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { ServiceGroupQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';
export const GET_SERVICE_GROUPS_FROM_SERVER = '[LABOUR OPERATIONS] Get Service Groups From Server';
export class GetServiceGroupsFromServer implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICE_GROUPS_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: ServiceGroupQueryParameters) {}
}

export const GET_SERVICE_GROUPS_FROM_SERVER_SUCCESS = '[LABOUR OPERATIONS] Get Service Groups From Server Success';
export class GetServiceGroupsFromServerSuccess implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICE_GROUPS_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { serviceGroups: ServiceGroup[] }) {}
}

export const GET_SERVICE_GROUPS_FROM_SERVER_FAILURE = '[LABOUR OPERATIONS] Get Service Groups From Server Failure';
export class GetServiceGroupsFromServerFailure implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_SERVICE_GROUPS_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = true;
  constructor(public payload: { error: any }) {}
}

export type ServicegroupsAction =
  | GetServiceGroupsFromServer
  | GetServiceGroupsFromServerSuccess
  | GetServiceGroupsFromServerFailure;
